var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgChevronLeft = function SvgSvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.725 20a1.992 1.992 0 0 1-1.438-.61l-7.727-8a2.002 2.002 0 0 1 .026-2.804l8-8a1.998 1.998 0 0 1 2.829 0c.78.782.78 2.046 0 2.828l-6.61 6.61 6.358 6.586A2 2 0 0 1 9.725 20Z",
    fill: "currentColor"
  })));
};
export default SvgSvgChevronLeft;